import { getUserConfigAPI, updateUserConfigAPI } from '../sevices/userConfigService';

export const getUserConfig = (token) => async (dispatch) => {
  await dispatch(getUserConfigAPI(token));
};